import { gql } from "@apollo/client";
import { FRAGMENT_SHIPMENT_INVOICE } from "./invoices/graphql";
import { FRAGMENT_SHIPMENT_STATUS } from "./status/graphql";

export const FRAGMENT_SHIPMENT = gql`
  fragment shipment on ShipmentType {
    id
    isEffective
    source {
      id
    }
    children {
      edges {
        node {
          id
        }
      }
    }
    invoiceNumber
    po
    note
    customer {
      id
      name
      odooPartnerId
      system
      user {
        id
        email
      }
      subAccounts {
        id
        user {
          id
          email
        }
      }
      lastUsedCurrency
      shippingZone
    }
    shipmentStatus {
      ...shipmentStatus
    }
    latestStatus
    consigneeName
    deliveryName
    addr
    deliveryAddr
    notifyPartyName
    notifyParty
    shippingMark
    extraEmails
    blNumber
    shipContainer
    countryOfOrigin
    vv
    containerNumber
    shippingTerm
    loadingPort
    requestCargoReadyDate
    dateOfDeliveryToPort
    etd
    eta
    newEtd
    newEta
    shipBy
    shipFrom
    shipTo
    portOfDischarge
    portOfDestination
    shipmentInvoices {
      ...shipmentInvoice
    }
    totalQty
    totalCarton
    totalNetWeight
    totalGrossWeight
    totalCbm
    attachments {
      id
      name
      uri
    }
    qcReports {
      id
      name
      status
      invoice {
        id
        number
      }
      factory {
        id
        name
      }
      sharedWithCustomerAt
      product {
        id
        name
      }
      productLine {
        id
        name
        mainImage
      }
      qty
      deletedAt
    }

    deletedAt
  }
  ${FRAGMENT_SHIPMENT_STATUS}
  ${FRAGMENT_SHIPMENT_INVOICE}
`;

export const FETCH_SHIPMENT = gql`
  query FETCH_SHIPMENT($id: ID!) {
    shipment(id: $id) {
      ...shipment
    }
    shipmentMeta {
      shipFrom
      shipBy
      shippingTerms
      loadingPorts
      shipmentStatusOptions
      errors {
        id
        code
        description
      }
    }
  }
  ${FRAGMENT_SHIPMENT}
`;

export const UPDATE_SHIPMENT = gql`
  mutation UPDATE_SHIPMENT($shipmentInput: ShipmentInput!) {
    updateShipment(shipmentInput: $shipmentInput) {
      shipment {
        ...shipment
      }
    }
  }
  ${FRAGMENT_SHIPMENT}
`;

export const SPLIT_SHIPMENT = gql`
  mutation SPLIT_SHIPMENT(
    $shipmentId: ID!
    $targets: [SplitShipmentTargetInput]!
  ) {
    splitShipment(shipmentId: $shipmentId, targets: $targets) {
      sourceShipment {
        id
      }
      shipments {
        id
        totalCbm
      }
    }
  }
`;

export const DELETE_SHIPMENT = gql`
  mutation DELETE_SHIPMENT($id: ID!) {
    deleteShipment(id: $id) {
      shipment {
        id
      }
    }
  }
`;

export const UPDATE_SHIPMENT_NOTE = gql`
  mutation UPDATE_SHIPMENT_NOTE($shipmentInput: ShipmentInput!) {
    updateShipment(shipmentInput: $shipmentInput) {
      shipment {
        id
        note
      }
    }
  }
`;
